"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _blocks = require("@bueno/blocks");

var _RuleItem = require("./RuleItem");

var _ProjectSettings = require("../ProjectSettings.styles");

var _useRuleSettings = require("../hooks/useRuleSettings");

var _ToggleList = require("./ToggleList.styles");

const RulesBox = /*#__PURE__*/React.memo(props => {
  const {
    ruleList,
    onRuleSelect,
    selectedRule
  } = props;
  const {
    handleCheck,
    checked,
    propagated,
    updateActive,
    clearAll,
    selectAll
  } = (0, _useRuleSettings.useRuleSettings)();
  if (ruleList.length < 1) return /*#__PURE__*/React.createElement(_ProjectSettings.BoxContent, null);
  return /*#__PURE__*/React.createElement(_blocks.FilterList, {
    items: ruleList,
    filterKey: "filterable",
    filterDelay: 500
  }, ({
    visible
  }) => {
    const rules = visible.reduce((acc, rule) => {
      // tslint:disable-next-line: strict-type-predicates
      if (propagated[rule.rule.id] !== undefined) {
        acc.active.push(rule);
      } else {
        acc.inactive.push(rule);
      }

      return acc;
    }, {
      active: [],
      inactive: []
    });
    return /*#__PURE__*/React.createElement(_ProjectSettings.BoxContent, {
      onMouseLeave: updateActive
    }, /*#__PURE__*/React.createElement(_ToggleList.ListSection, {
      style: {
        background: _blocks.palette.neutral2
      }
    }, rules.active.length > 0 && /*#__PURE__*/React.createElement(_ToggleList.InlineAction, {
      onClick: clearAll(rules.active)
    }, "Clear all"), rules.active.map(rule => {
      return /*#__PURE__*/React.createElement(_RuleItem.RuleItem, {
        key: rule.rule.id,
        rule: rule,
        onRuleChecked: handleCheck,
        onRuleSelect: onRuleSelect,
        isActive: selectedRule !== undefined && rule.rule.id === selectedRule.rule.id,
        isChecked: true
      });
    })), /*#__PURE__*/React.createElement(_ToggleList.ListSection, null, rules.inactive.length > 0 && /*#__PURE__*/React.createElement(_ToggleList.InlineAction, {
      onClick: selectAll(rules.inactive)
    }, "Select all"), rules.inactive.map(rule => {
      return /*#__PURE__*/React.createElement(_RuleItem.RuleItem, {
        key: rule.rule.id,
        rule: rule,
        onRuleChecked: handleCheck,
        onRuleSelect: onRuleSelect,
        isActive: selectedRule !== undefined && rule.rule.id === selectedRule.rule.id // tslint:disable-next-line: strict-type-predicates
        ,
        isChecked: checked[rule.rule.id] !== undefined
      });
    })));
  });
}, (p, n) => p.activeProject === n.activeProject && p.selectedRule === n.selectedRule);
var _default = RulesBox;
exports.default = _default;
module.exports = exports.default;